import xw from 'xwind';
import styled from '@emotion/styled';
import { Section } from '@/components/layout';

export const StyledSection = styled(Section)`
  ${xw`flex items-center`}
  min-height: calc(100vh - 3.75rem);

  @media (min-width: 1280px) {
    min-height: calc(100vh - 6.25rem);
  }
`;

export const ImageWrapper = styled.div`
  ${xw`w-full h-full`}

  display: none;

  @media (min-width: 1024px) and (orientation: portrait) {
    display: flex;
    justify-content: flex-end;
  }

  @media (min-width: 1024px) and (orientation: landscape) {
    display: flex;
    justify-content: flex-end;
  }
`;

export const ImageContainer = styled.div(xw`w-4/5`);

export const Image = styled.img(xw`w-full h-full`);

export const ContentCotainerWrapper = styled.div(
  xw`
    w-full min-h-full flex flex-col
    `,
);

export const ContentCotainer = styled.div(xw`w-full`);

export const Title = styled.h1(
  xw`text-2xl md:text-4xl text-gray-700 text-center mb-4`,
);

export const Line = styled.hr(
  xw`
    mx-auto h-0.5 rounded-sm
    border-0 bg-secondary
    w-60 mb-8 md[w-80 mb-16]
  `,
);

export const Text = styled.p(
  xw`
    text-base mb-4 last:mb-0
    md[text-xl mb-8] text-gray-900
  `,
);
